<template>
  <nav class="nav-extended blue-nav">
    <div class="nav-wrapper">
      <div>
        <a href="/categories">
          <i class="material-icons">chevron_left</i>
        </a>
      </div>
      <div class="nav-info">
        <div class="title">category editor</div>
        <div class="changes">
          changes saved automatically
          <div id="lastUpdated">
            (last saved:
            <div id="lastUpdatedDate"></div>)
          </div>
        </div>
      </div>
      <div class="help" @click="helpClick()">
        <i class="material-icons">{{helpSidebarOpen ? 'close' : 'help_outline' }}</i>
      </div>
    </div>
    <div id="helpSidebar" class="z-depth-3" :class="{open: helpSidebarOpen}">
      <div v-if="!tutorialSelected" class="help-menu">
        <iframe src="https://dashboard.fyiio.com/s/gsL7roTD" width="100%" height="800" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
      </div>
      <div class="tutorial-wrap" v-if="tutorialSelected">
        <iframe
          v-bind:src="tutorialSelected"
          width="375"
          height="300"
          frameborder="0"
          allowfullscreen="allowfullscreen"
        ></iframe>
      </div>
    </div>
  </nav>
</template>

<script>
// creating tutorials https://dashboard.fyiio.com/viewer/5616f205-cd99-420a-931f-c2660e59d204
// updating https://dashboard.fyiio.com/viewer.html#tutorial/5653d5fe-44b0-4c92-b99a-c79b0ec6d234

export default {
  mounted() {},
  updated() {},
  name: "CategoryEditorNav",
  data() {
    return {
      helpSidebarOpen: false,
      tutorialSelected: false
    };
  },
  methods: {
    helpClick() {
      if (this.helpSidebarOpen) {
        this.tutorialSelected = false;
        $("#app").removeClass("sidebarOpen");
      } else {
        $("#app").addClass("sidebarOpen");
      }
      this.helpSidebarOpen = !this.helpSidebarOpen;
    },
    selectTutorial(tutorial) {
      this.tutorialSelected = tutorial;
    }
  }
};
</script>
<style scoped>
#lastUpdated {
  display: inline-block;
  display: none;
  font-style: italic;
}
#lastUpdatedDate {
  display: inline-block;
}
iframe {
  height: calc(100vh - 80px);
}
.tutorial-wrap {
  margin-top: -24px;
}
ol {
  list-style: none;
  counter-reset: item;
  padding: 0;
}
li {
  cursor: pointer;
  counter-increment: item;
  width: 350px;
  margin: 24px auto;
  height: 40px;
  line-height: 40px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
}
li:before {
  margin-right: 10px;
  width: 40px;
  text-align: center;
  content: counter(item);
  background: #616161;
  color: white;
  text-align: center;
  display: inline-block;
  line-height: 40px;
}
.help-steps li {
  color: black;
}
h2 {
  text-align: center;
  padding: 24px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  margin: 0;
}
.help-logo {
  margin-top: 24px;
  top: 24px;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  border: 4px solid #58595b;
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.help-logo img {
  height: 27px;
  width: 50px;
}
#helpSidebar {
  padding-top: 24px;
  position: absolute;
  right: -400px;
  width: 375px;
  min-height: calc(100vh - 65px);
  top: 65px;
  z-index: 1000;
  background: white;
  transition: all 0.25s ease-in;
}
#helpSidebar.open {
  right: 0;
}
.help {
  cursor: pointer;
}
nav {
  padding: 0;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.nav-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding-left: 13px;
  padding-right: 13px;
  z-index: 10;
}
.nav-info {
  text-align: center;
}
.title {
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  padding: 0;
}
.changes {
  text-align: center;
  font-size: 12px;
  line-height: 16px;
}
.material-icons {
  font-size: 24px;
}
i {
  margin-left: 25px;
  margin-right: 25px;
}
</style>

<style scoped>

@media only screen and (min-width: 1000px) {
#app {
  width: 100%;
      transition: all 0.25s ease-in;

}
#app.sidebarOpen {
  width: calc(100vw - 375px);
}
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryEditorNav.vue